import { useAccess } from "src/hooks/useAccess.hook";
import editFill from "@iconify/icons-eva/edit-fill";
import deleteFill from "@iconify/icons-eva/trash-2-outline";
import viewFill from "@iconify/icons-eva/eye-fill";
import { ActionsMenu } from "../Actions/ActionsMenu";
import { useMutate } from "src/hooks/useFetch.hook";
import { getCompanyUrlId } from "src/react-query/endPoints";
import { useCallback, useMemo } from "react";
import { FEATURE } from "src/util/enums";
import { useDispatch, useSelector } from "react-redux";
import { authSlice } from "src/store/auth/auth.slice";
export const CompanyActionMenu = ({ id }) => {
  const isReadOnly = useAccess(FEATURE.COMPANY, "R");
  const hasEditAccess = useAccess(FEATURE.COMPANY, "U");
  const hasDeleteAccess = useAccess(FEATURE.COMPANY, "D");
  const { user } = useSelector(({ auth }) => auth);
  const dispatch = useDispatch();
  const { mutate} = useMutate("companyList");
  const updateProfileRoles = useCallback(() => {
    const updatedRoles = user?.role.filter(
      (team) => Number(team.teamId) !== Number(id)
    );
    const updatedUser = { ...user, role: updatedRoles };
    dispatch(authSlice.actions.setUser(updatedUser));
  }, [id,dispatch,user]);
  
  const onDelete = useCallback(() => {
    mutate(
      { url: getCompanyUrlId(id), method: "DELETE" },
      { onSuccess: updateProfileRoles }
    );
  }, [id, mutate,updateProfileRoles]);
  const actionList = useMemo(
    () => [
      {
        id: "view",
        title: "View",
        icon: viewFill,
        routerLink: `${id}`,
        hidden: !isReadOnly,
      },
      {
        id: "edit",
        title: "Edit",
        icon: editFill,
        routerLink: `${id}`,
        hidden: !hasEditAccess,
      },
      {
        id: "delete",
        title: "Delete",
        icon: deleteFill,
        action: onDelete,
        hidden: !hasDeleteAccess,
      },
    ],
    [id, isReadOnly, hasEditAccess, hasDeleteAccess, onDelete]
  );

  return <ActionsMenu menuList={actionList} />;
};
